var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.isRouterAlive1)?_c('BasicLayout',[_c('div',{staticClass:"container",style:({ minHeight: (_vm.height + "px") })},[_c('transition',{attrs:{"name":"move","mode":"out-in"}},[(_vm.isRouterAlive)?_c('router-view',{attrs:{"viewHeight":_vm.height}}):_vm._e()],1)],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-58fb5e24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Home.vue
// module id = null
// module chunks = 